<template>
  <div class="sectionBox">
    <div class="legendBox" :class="popFlag?'hideScroll':''" :style="{ backgroundImage: 'url(' + bg1 + ')' }">
      <p class="tipsBox">
        <span class="tips" @click="popFlag = true"></span>
      </p>
      <p class="urlBtnBox" @click="urlBtn"></p>
    </div>
    <div class="tipsPopBox" v-if="popFlag" @click.self="popFlag = false">
      <img :src="pop1" alt="">
      <span class="closeBtn" @click="popFlag = false"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ramadan",
  data() {
    return {
      userInfo: [],
      bg1:'',
      pop1:'',
      popFlag: false
    };
  },
  mounted() {
      this.$completes.complete("getUserInfo");
      window.getUserInfo = this.getUserInfo;
      window['getUserInfo'] = (data) => {
          this.getUserInfo(data);
      }
  },
  methods: {
    getUserInfo(data) {
      this.userInfo = JSON.parse(data);
      let langs = this.userInfo.lang.substring(0, 2)
      if (langs == "en") {
        this.$i18n.locale = "en";
        this.bg1 = require("../../assets/ramadan/bgEn.png");
        this.pop1 = require("../../assets/ramadan/popEn.png");
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
        this.bg1 = require("../../assets/ramadan/bgAr.png");
        this.pop1 = require("../../assets/ramadan/popAr.png");
      } else {
        this.bg1 = require("../../assets/ramadan/bgEn.png");
        this.pop1 = require("../../assets/ramadan/popEn.png");
      }
      document.title = 'Legend Ramadan';
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    },
    urlBtn() {
      window.location.href = "https://laylachat.feishu.cn/wiki/RWjyw5m4fijqHEkrU25cz09qnNg?renamingWikiNode=false&sheet=b5FqYj"
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.legendBox{
  width: 100%;
  height: 47.23rem;
  background-size: 100% 47.23rem;
  background-repeat: no-repeat;
}
.hideScroll{
  height: 14rem;
}
.tipsBox{
  height: 0.3rem;
  padding-top: 0.3rem;
}
.tipsBox span{
    float: right;
    width: 0.5rem;
    height: 0.5rem;
    margin-right: 0.2rem;
  }
.tipsPopBox{
  width: 100%;
  position: absolute;
  height: 14rem;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.5);
  
}
.tipsPopBox img{
    width: 6.08rem;
    height: 10.08rem;
    position: absolute;
    top: 1.92rem;
    left: 50%;
    transform: translateX(-50%);
  }
.urlBtnBox{
  width: 4.5rem;
  height: 0.5rem;
  margin: 0 auto;
  margin-top: 1.6rem;
}
.sectionBox{
  position: relative;
}
.closeBtn{
  width:0.52rem;
  height: 0.52rem;
  background-image: url("../../assets/ramadan/close.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 1.2rem;
  left: 50%;
  transform: translateX(-50%);
}
</style>
